module.exports = __webpack_public_path__ + "static/media/meeting1.528d9f0a.jpg";